import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import externalApi from '../../api';

type EditEquipmentTypeRequest = {
  equipmentTypeId: string;
  name: string;
  lastUpdatedUserId: string;
};

type EditEquipmentTypeResponse = {
  equipmentId: number;
};

function editEquipmentType(request: EditEquipmentTypeRequest): Promise<EditEquipmentTypeResponse> {
  return externalApi.put(`EquipmentType/put`, { json: request }).json();
}

function useEditEquipmentType() {
  const queryClient = useQueryClient();
  return useMutation((request: EditEquipmentTypeRequest) => editEquipmentType(request), {
    onSuccess: () => {
      queryClient.invalidateQueries(['EquipmentTypes']);
    },
  });
}
export { useEditEquipmentType };
